import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

import { Link } from "react-router-dom";

import logoLightSvg from "assets/images/logo-light.svg";
import logoDarkSvg from "assets/images/logo-dark.svg";
import logoLightPng from "assets/images/ACES_WHITE.png";
import newLogo from "assets/images/ACES_WHITE.png";

const Sidebar = (props) => {
  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box text-start">
          {/* Skote Logo Dark */}
          <Link to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src={logoDarkSvg} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={newLogo} alt="" height="60" />
            </span>
          </Link>

          {/* Skote Logo Light */}
          <Link to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src={logoLightSvg} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoLightPng} alt="" height="80" />
            </span>
          </Link>
        </div>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
